var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tags",attrs:{"color":_vm.color}},_vm._l((_vm.tags),function(item){return _c('div',{key:item[_vm.valueField],staticClass:"tag-item",class:{ 'tag-selected': item[_vm.valueField] === _vm.selected }},[_vm._t("tag",function(){return [_vm._v(" "+_vm._s(item[_vm.textField])+" ")]},null,{ item })],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }